// FigureReveal — the entrance for a KPI figure once its real value is known.
//
// Data tiles used to count up from 0 (useCountUp). Every frame of that
// animation is a number on screen, and on the iPad the in-between frames
// read as real figures: Gastos showed "Por pagar $0k / Vencidos 0" in red
// before $219k / 16, and Pacientes showed "Activos 4,615 · En proceso 1 ·
// WhatsApp 277" before 6,187 / 3 / 2,861, next to a header that already had
// the final numbers (iOS round-5 N1 / N2). A tile now shows '—' until its
// data arrives and then the final figure, which fades in once.
//
// Render it only around a real value (never around the '—' placeholder):
// the span mounts on the pending → value switch, so the fade plays once and
// later value changes (mark paid, a realtime count bump) swap in place.
import type { ReactNode } from 'react';

export function FigureReveal({ children }: { children: ReactNode }) {
  return <span className="figure-reveal">{children}</span>;
}
